import React from 'react'
import AppLinks from '../AppLinks/index'
import Button, { TYPES as BUTTON_TYPES } from '../Button/index'
import { H2 } from '../Heading/index'

/**
 * The Share Page Hero Logos component
 * Displays a hero section with logos and a call-to-action button.
 *
 * @param {Object} props - Component props
 * @param {Object} props.staticText - Strings used for text content in the component
 * @param {string} props.offerLink - URL for the offer link
 * @param {function} props.onOfferClick - Callback function when the offer is clicked
 * @param {string} props.ctaLabel - Label text for the call-to-action button
 * @returns {JSX.Element} Hero logos section component
 */
function SharePageHeroLogos (props) {
  const {
    staticText,
    offerLink,
    onOfferClick,
    ctaLabel,
  } = props

  return (
    <div className="share-page__hero-logos">
      <div className="share-page__subtitle share-page__hero-logos-subtitle">{staticText.get('heroLogosSubtitle')}</div>
      <H2 className="share-page__title share-page__hero-logos-title">{staticText.get('heroLogosTitle')}</H2>
      <div className="share-page__hero-logos-image" />
      <div className="share-page__hero-logos-platforms">
        <AppLinks />
      </div>
      <Button
        className="share-page__banner-cta share-page__hero-logos-cta"
        type={BUTTON_TYPES.PRIMARY}
        onClick={onOfferClick}
        {...offerLink}
      >
        {ctaLabel}
      </Button>
    </div>
  )
}

export default SharePageHeroLogos
